import { inject, InjectionToken } from "@angular/core";
import { SideNavService } from "@app/shared-core/components/side-nav/services/side-nav.service";
import { NotificationSettingsRoutePaths } from "../notification-settings-route-path";
import { PERMISSION_CONSTANTS } from "@app/shared/auth/constants/permissions.constant";

export const NOTIFICATION_SETTING_SIDENAV_LINK = new InjectionToken<void>("NOTIFICATION_SETTING_SIDENAV_LINK", {
  providedIn: "root",
  factory: () => {
    const sideNavService = inject(SideNavService);
    sideNavService.addSubMenuItems("setting", [
      {
        id: "notification-settings",
        label: "NOTIFICATION_SETTINGS",
        routerLink: `/${NotificationSettingsRoutePaths.BASE_URL}`,
        permissions: [PERMISSION_CONSTANTS.STOCK_NOTIFICATION_SETTINGS.VIEW, PERMISSION_CONSTANTS.QUOTATION_NOTIFICATION_SETTINGS.VIEW],
        icon: "alarm",
      },
    ]);
  },
});
